import React from 'react';
import ReactLoading from 'react-loading';

export default function LoadingComponent({ loading }: { loading: boolean }): JSX.Element {
  if (!loading) return <span />;
  return <ReactLoading type="spin" color="#fff" />;
}
